import useYesObject from 'modules/shared/hooks/useYesObject'
import {
  FlatActivityModelInteractionReview,
  Interaction,
  InteractionModel
} from 'types/shared'
import Review from '../../Review'
import { useAppSelector } from 'state/store'
import { useSearchParams } from 'react-router-dom'
import useDataFromWorkflow from 'modules/interaction/hooks/useDataFromWorkflow'

type ActivityInteractionReviewProps = {
  activityModel: FlatActivityModelInteractionReview
}

const externalSources: FlatActivityModelInteractionReview['interaction_info']['source'][] =
  ['query_string', 'process_state']

export default function ActivityInteractionReview({
  activityModel
}: ActivityInteractionReviewProps) {
  const {
    source,
    identifier,
    displayed_activity_models: displayedActivityModels
  } = activityModel.interaction_info

  const shouldFetchInteraction = externalSources.includes(source)

  const { getVariableFromProcessState } = useDataFromWorkflow()

  const [searchParams] = useSearchParams()
  const uuidFromQueryString = searchParams.get(identifier) || undefined

  const uuidFromDataContainer = getVariableFromProcessState(identifier)

  const uuidSources: Record<typeof source, string | undefined> = {
    query_string: uuidFromQueryString,
    process_state: uuidFromDataContainer,
    internal: undefined
  }

  const externalInteractionUuid = uuidSources[source]

  const { yesObject: externalInteraction } = useYesObject<Interaction>({
    objectclassUUID: window.interactionObjectclassUuid,
    objectUUID: shouldFetchInteraction ? externalInteractionUuid : undefined
  })

  const {
    flatData: internalFlatData,
    userName: internalUser,
    dateStartInteraction: internalDateStartInteraction,
    geolocation: internalGeolocation
  } = useAppSelector((state) => state.interactionModel)

  const externalInteractionState =
    (JSON.parse(externalInteraction?.state || '{}') as InteractionModel) || {}

  const {
    flatData: externalFlatData,
    userName: externalUser,
    dateStartInteraction: externalDateStartInteraction,
    geolocation: externalGeolocation
  } = externalInteractionState

  const flatData = shouldFetchInteraction ? externalFlatData : internalFlatData

  const userName = shouldFetchInteraction ? externalUser : internalUser

  const dateStartInteraction = shouldFetchInteraction
    ? externalDateStartInteraction
    : internalDateStartInteraction

  const geolocation = shouldFetchInteraction
    ? externalGeolocation
    : internalGeolocation

  if (!flatData) return null

  return (
    <Review
      onSave={() => {}}
      goToStep={() => {}}
      flatData={flatData}
      userName={userName}
      dateStartInteraction={dateStartInteraction}
      geolocation={geolocation}
      displayedActivityModels={displayedActivityModels}
      reviewActivity
      displayMetadata={activityModel.display_metadata}
    />
  )
}
